import React from 'react';
import './ReportModal.css';

function ReportModal({ isOpen, onClose, onGenerateReport, isGenerating }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Generate report</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <hr />
        
        <div className="modal-body">
          <p className="modal-description">Please choose the format for your report:</p>
          
          <div className="format-options">
            <div className="format-option">
              <div className="format-icon word">
                <span>W</span>
              </div>
              <div className="format-details">
                <h3>Microsoft Word</h3>
                <p>Ideal for internal review and sharing purposes</p>
              </div>
              <button 
                className="generate-button"
                onClick={() => onGenerateReport('word')}
                disabled={isGenerating}
              >
                {isGenerating ? 'Generating...' : 'Generate report'}
              </button>
            </div>

            <div className="format-option">
              <div className="format-icon pdf">
                <span>P</span>
              </div>
              <div className="format-details">
                <h3>PDF Document</h3>
                <p>Perfect for formal submissions and archiving</p>
              </div>
              <button 
                className="generate-button"
                onClick={() => onGenerateReport('pdf')}
                disabled={isGenerating}
              >
                {isGenerating ? 'Generating...' : 'Generate report'}
              </button>
            </div>

            <div className="format-option">
              <div className="format-icon csv">
                <span>C</span>
              </div>
              <div className="format-details">
                <h3>CSV File</h3>
                <p>Best for data analysis and spreadsheet integration</p>
              </div>
              <button 
                className="generate-button"
                onClick={() => onGenerateReport('csv')}
                disabled={isGenerating}
              >
                {isGenerating ? 'Generating...' : 'Generate report'}
              </button>
            </div>

            <div className="format-option">
              <div className="format-icon canva">
                <span>Ca</span>
              </div>
              <div className="format-details">
                <h3>Canva Design</h3>
                <p>Create visually appealing presentations and infographics</p>
              </div>
              <button 
                className="generate-button"
                onClick={() => onGenerateReport('canva')}
                disabled={isGenerating}
              >
                {isGenerating ? 'Generating...' : 'Generate report'}
              </button>
            </div>

            <div className="format-option">
              <div className="format-icon xbrl">
                <span>X</span>
              </div>
              <div className="format-details">
                <h3>XBRL Document</h3>
                <p>Standard format for business reporting and regulatory filing</p>
              </div>
              <button 
                className="generate-button"
                onClick={() => onGenerateReport('xbrl')}
                disabled={isGenerating}
              >
                {isGenerating ? 'Generating...' : 'Generate report'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportModal; 